import { call } from 'typed-redux-saga';

import { isInsideIframe } from '../../helpers/iframe';
import { parentFrameCommunicator } from './parent-frame-communicator';

export function* initIframeCommunicationSaga(): Generator {
    if (NODE || !isInsideIframe()) {
        return;
    }

    yield* call(parentFrameCommunicator.init);
}
